<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jteal1/tc-custom/9781507209875.jpg?1730528480932" alt="This image is the cover for the book Little Book of Self-Care for Pisces, Astrology Self-Care"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Little Book of Self-Care for Pisces, Astrology Self-Care
      </h1>
      <p class="bookDescription body article font2">
        <b>Everything you need to know about self-care—especially for Pisces!</b><br/><br/>Take Time for You, Pisces!<br/><br/>It’s me time—powered by the zodiac!<b></b>Welcome star-powered strength and cosmic relief into your life with <i>The Little Book of Self-Care for Pisces</i>.<br/><br/>While Pisces may value community, this book truly puts you first. Let the stars be your guide as you learn just how important astrology is to your self-care routine. Discover more about your sign and your ruling element, water, and then find the perfect set of self-care ideas and activities for you.<br/><br/>From savoring a home-cooked meal to creating a personal altar, you will find more than one hundred ways to heal your mind, body, and active spirit. It’s stellar self-care especially for you, Pisces!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Constance Stellas
      </h2>
      
      <p class="authorDescription body article">Constance Stellas is an astrologer of Greek heritage with over twenty-five years of experience. She primarily practices in New York City and counsels a variety of clients, including business CEOs, artists, and scholars. She has been interviewed by&#160;<I>The New York Times</I>, <I>Marie Claire</I>,&#160;and<I>&#160;Working Woman</I>&#160;and appeared on several New York TV morning shows and national radio programs. Constance is the astrologer for&#160;<I>HuffPost</I>&#160;and a regular contributor to&#160;<I>Thrive Global</I>. She is also the author of several titles, including<I>&#160;Sex Signs</I>, <I>How to Be an Astrologer</I>,&#160;the&#160;Astrological Self-Care&#160;series, and more. Learn more about Constance at her website, ConstanceStellas.com, or on Twitter (@StellaStarGuide).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Adams Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6bc376f6